import { render, staticRenderFns } from "./SendList.vue?vue&type=template&id=15f3c2fc&scoped=true&"
import script from "./SendList.vue?vue&type=script&lang=js&"
export * from "./SendList.vue?vue&type=script&lang=js&"
import style0 from "./SendList.vue?vue&type=style&index=0&id=15f3c2fc&lang=scss&scoped=true&"
import style1 from "./SendList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3c2fc",
  null
  
)

export default component.exports